function appHeaders () {
  const appToken = JSON.parse(localStorage.getItem('open-agf.jwt.token') || 'null')
  return new Headers({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${appToken}`,
  })
}

export { appHeaders }
